import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20eb3c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "af12-modal" }
const _hoisted_2 = {
  class: "flex h-full border border-line rounded-lg bg-white",
  style: {"min-width":"1300px"}
}
const _hoisted_3 = {
  class: "relative border-r border-line w-20 md:w-48",
  style: {"min-width":"12rem"}
}
const _hoisted_4 = { class: "w-full text-c-desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-home text-c-default" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden ml-2 md:inline-block" }, "기본 설정", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-users text-c-default" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden ml-2 md:inline-block" }, "협력사 설정", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "af12-content relative" }
const _hoisted_12 = { class: "px-5 py-5" }
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "text-2xl font-semibold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-cross text-c-default" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 border-b border-line" }, null, -1))


import { ref, defineComponent, computed, defineEmits } from "vue";
import { useRouter } from "vue-router";

import SettingDefault from "./modal-setting-default.vue";
import SettingProcesses from "./modal-setting-processes.vue";

const __default__ = defineComponent({
  name: "AdminSetting",
  components: { SettingDefault, SettingProcesses },
  props: {
    msg: String,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onModalClose"],
  setup(__props, { emit }) {



const tabIdx = ref(0);

const modalTitle = computed(() => {
  if (0 === tabIdx.value) {
    return "기본 설정";
  } else if (1 === tabIdx.value) {
    return "협력사 설정";
  }

  return "기본 설정";
});

const onTab = (idx: number) => {
  tabIdx.value = idx;
};

const onModalClose = () => {
  emit("onModalClose");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass(["af12-left-menu", { active: 0 === tabIdx.value }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onTab(0)), ["stop"]))
          }, _hoisted_7, 2),
          _createElementVNode("li", {
            class: _normalizeClass(["af12-left-menu", { active: 1 === tabIdx.value }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onTab(1)), ["stop"]))
          }, _hoisted_10, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(modalTitle.value), 1),
            _createElementVNode("button", {
              class: "cs-icon-btn1",
              onClick: onModalClose
            }, _hoisted_16)
          ]),
          _hoisted_17
        ]),
        (0 === tabIdx.value)
          ? (_openBlock(), _createBlock(SettingDefault, { key: 0 }))
          : _createCommentVNode("", true),
        (1 === tabIdx.value)
          ? (_openBlock(), _createBlock(SettingProcesses, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})